<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
  >
    <!-- 오버레이 (배경) -->
    <div
      class="absolute inset-0 bg-black bg-opacity-50"
      @click="$emit('close')"
    ></div>

    <div class="bg-white rounded-xl shadow-xl w-[500px] p-1 z-10">
      <!-- 상단 제목줄 -->
      <div class="bg-gray-500 px-4 py-3 font-bold text-white text-center h-12">
        비밀번호 변경

        <div class="flex justify-end -mt-8 -mr-2">
          <UCButton
            label="닫기"
            icon="close"
            width="80px"
            @click="$emit('close')"
          />
        </div>
      </div>

      <p class="text-sm text-black mt-4 mb-4">
        보안을 위해 현재 비밀번호를 입력한 후 새 비밀번호를 설정하세요.
      </p>

      <UCText
        class="pl-2"
        label="현재 비밀번호"
        v-model="currentPassword"
        type="password"
        widthLabel="170px"
      />

      <UCText
        class="pl-2 pt-4"
        label="새 비밀번호"
        v-model="newPassword"
        type="password"
        widthLabel="170px"
      />

      <p class="pl-4 pt-1 text-xs text-gray-500">
        최소 8자, 대문자, 소문자, 숫자 포함
      </p>

      <UCText
        class="pl-2 pt-3"
        label="새 비밀번호 확인"
        v-model="confirmPassword"
        type="password"
        widthLabel="170px"
      />

      <p v-if="errorMessage" class="text-red-500 text-sm mb-4 pl-4">
        {{ errorMessage }}
      </p>

      <!-- 버튼 영역 -->
      <div class="flex justify-center gap-3 pt-4 mb-2">
        <UCButton
          label="비밀번호 변경"
          icon="lock"
          width="150px"
          @click="handleChangePassword"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { notify } from "@kyvg/vue3-notification";

import UCText from "@/components/UserControl/UCText.vue";
import UCButton from "@/components/UserControl/UCButton.vue";

const props = defineProps({
  isOpen: Boolean,
});
const emit = defineEmits(["close"]);

const currentPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");

const showCurrent = ref(false);
const showNew = ref(false);
const showConfirm = ref(false);

// 팝업이 열릴 때 값 초기화
watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      currentPassword.value = "";
      newPassword.value = "";
      confirmPassword.value = "";

      showCurrent.value = false;
      showNew.value = false;
      showConfirm.value = false;

      errorMessage.value = "";
    }
  }
);

const handleChangePassword = () => {
  if (validatePassword()) {
    console.log(
      `currentPassword[${currentPassword.value}] newPassword[${newPassword.value}] confirmPassword[${confirmPassword.value}]`
    );

    notify({
      title: "실패",
      text: "비밀번호 변경 API 호출이 필요합니다.",
      type: "error",
    });

    // 비밀번호 변경 API 호출

    // notify({
    //   title: "성공",
    //   text: "비밀번호 변경되었습니다.",
    //   type: "success",
    // });
  }
};

const errorMessage = ref("");
const validatePassword = () => {
  const password = newPassword.value;

  // 최소 길이
  if (password.length < 8) {
    errorMessage.value = "비밀번호는 최소 8자 이상이어야 합니다.";
    return false;
  }

  // 대문자 포함 여부
  if (!/[A-Z]/.test(password)) {
    errorMessage.value =
      "비밀번호에는 대문자가 최소 1자 이상 포함되어야 합니다.";
    return false;
  }

  // 소문자 포함 여부
  if (!/[a-z]/.test(password)) {
    errorMessage.value =
      "비밀번호에는 소문자가 최소 1자 이상 포함되어야 합니다.";
    return false;
  }

  // 숫자 포함 여부
  if (!/[0-9]/.test(password)) {
    errorMessage.value = "비밀번호에는 숫자가 최소 1자 이상 포함되어야 합니다.";
    return false;
  }

  // 특수문자 포함 여부 (선택)
  if (!/[!@#$%^&*]/.test(password)) {
    errorMessage.value = "비밀번호에는 특수문자가 포함되어야 합니다.";
    return false;
  }

  // 비밀번호 확인 일치 여부
  if (newPassword.value !== confirmPassword.value) {
    errorMessage.value = "비밀번호가 일치하지 않습니다.";
    return false;
  }

  errorMessage.value = "";
  return true;
};
</script>
